import React from 'react';

const ProjectApproach = () => {
  const phases = [
    {
      number: "01",
      title: "Risk Analysis",
      description: "Comprehensive hazard identification and risk assessment",
      activities: [
        "HAZOP review participation",
        "Risk matrix development",
        "Consequence modeling",
        "Frequency analysis"
      ],
      duration: "2-4 weeks"
    },
    {
      number: "02",
      title: "Gap Assessment",
      description: "Detailed evaluation of current safety systems against requirements",
      activities: [
        "Documentation review",
        "Field verification",
        "Compliance mapping",
        "Recommendations report"
      ],
      duration: "3-6 weeks"
    },
    {
      number: "03",
      title: "Digital Migration",
      description: "Transformation to modern safety lifecycle management",
      activities: [
        "Data structure design",
        "System implementation",
        "User training",
        "Go-live support"
      ],
      duration: "8-12 weeks"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Project Approach</h2>
          <p className="text-xl text-gray-600">Systematic methodology for success</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {phases.map((phase, index) => (
            <div key={index} className="relative">
              <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow h-full">
                <div className="absolute -top-6 left-8 bg-blue-600 text-white text-3xl font-bold w-16 h-16 rounded-full flex items-center justify-center">
                  {phase.number}
                </div>
                <div className="mt-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{phase.title}</h3>
                  <p className="text-gray-600 mb-4">{phase.description}</p>
                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Key Activities:</h4>
                    <ul className="space-y-1">
                      {phase.activities.map((activity, idx) => (
                        <li key={idx} className="flex items-center text-gray-700 text-sm">
                          <i className="fas fa-arrow-right text-blue-500 mr-2 text-xs"></i>
                          <span>{activity}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="pt-4 border-t border-gray-200">
                    <span className="text-sm text-gray-500">
                      <i className="fas fa-clock mr-2"></i>Typical Duration: {phase.duration}
                    </span>
                  </div>
                </div>
              </div>
              {index < phases.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="fas fa-chevron-right text-3xl text-blue-600"></i>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="bg-white p-12 rounded-lg shadow-lg">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Why Our Approach Works</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-500 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Proven Methodology</h4>
                    <p className="text-gray-600">Refined through 120+ successful projects</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-500 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Flexible Implementation</h4>
                    <p className="text-gray-600">Adapted to your facility's unique needs</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="fas fa-check-circle text-green-500 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900">Continuous Support</h4>
                    <p className="text-gray-600">Partnership beyond project completion</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="/assets/asset-22.jpg"
                alt="Technical team"
                className="rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectApproach;
